import { Button, Carousel, CarouselItem, Container } from "reactstrap";
import cultureEventBg from "../../assets/culture-event-bg.png";
import Header from "../../components/globals/Header";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import ResturantBasicDetails from "../../components/page-sections/ResturantBasicDetails";
import { IoArrowBackOutline, IoArrowForwardOutline, IoFemale, IoMaleOutline } from "react-icons/io5";
import ResturantsDiscountsDetail from "../../components/page-sections/ResturantsDiscountsDetail";
import ResturantGalleryDetails from "../../components/page-sections/ResturantGalleryDetails";
import ResturantReviews from "../../components/page-sections/ResturantReviews";
import BookLet from "../../components/specials/BookLet";
import { useGoBack } from "../../utils";
import ResturantDeals from "../../components/page-sections/ResturantDeals";
import ResturantSpecialEvent from "../../components/page-sections/ResturantSpecialEvent";
import { useTranslation } from "../../languages";

const CultureEventDetails = () => {
  const { state } = useLocation();
  const goBack = useGoBack();
  const { t } = useTranslation();
  //other details are sent here
  const slideItems = [
    <ResturantBasicDetails details={state} />,
    <ResturantsDiscountsDetail details={state} />,
    <ResturantDeals details={state} />,
    <ResturantSpecialEvent details={state} />,
    <ResturantGalleryDetails details={state} />,
    <ResturantReviews />,
  ];
  //

  return (
    <div>
      <Container fluid>
        <Header title={"My Places"} />
        <div
          style={{ minHeight: "50px" }}
          className="bg-white d-flex px-3  mb-4 align-items-center justify-content-between full-width"
        >
          <h5 className="f-6 color-primary-blue m-0">
            {state?.title}{" "}
            {state?.genderType === "male" ? (
              <IoMaleOutline size={30} color="blue" />
            ) : (
              <IoFemale size={30} color="rgb(157, 1, 85)" />
            )}
          </h5>
          <div className="d-flex align-items-center gap-3">
            <Link
              to={"/places/editplace"}
              state={state}
              className="btn text-white text-decoration-none standard-rounded-btn px-4  py-2 inner-shadow-white"
            >
              {t("edit")}
            </Link>
            <Button
              onClick={() => goBack()}
              className="standard-rounded-btn   py-2 inner-shadow-white"
            >
              {t("close")}
            </Button>
          </div>
        </div>
        <BookLet pageBackground={cultureEventBg} title={state?.title}>
          {slideItems?.map((item, key) => item)}
        </BookLet>
      </Container>
    </div>
  );
};

export default CultureEventDetails;
